import React from "react";
import { IoPause } from "react-icons/io5";
import { MdOutlineModeEdit } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaPlay } from "react-icons/fa6";
import { AiOutlineRedo } from "react-icons/ai";

const ActionsBtn = (props) => {
  const { btnName, onClick } = props;
  return (
    <button
      onClick={onClick}
      className={`text-xs border p-1 rounded-[5px] w-16 hover:text-white ${
        btnName === "Pause"
          ? "border-[#E76445] text-[#FA8008] hover:bg-[#E76445]"
          : btnName === "Edit"
          ? "border-[#5593FE] text-[#5593FE] hover:bg-[#457BD8]"
          : btnName === "Delete"
          ? "border-[#EB0000] text-[#EB0000] hover:bg-[#EB0000]"
          : "border-[#00BB25] text-[#00BB25] hover:bg-[#009E2F]"
      }`}
    >
      <div className="flex items-center gap-1">
        <span>
          {btnName === "Pause" ? (
            <IoPause />
          ) : btnName === "Edit" ? (
            <MdOutlineModeEdit />
          ) : btnName === "Delete" ? (
            <RiDeleteBin6Line />
          ) : btnName === "Run" ? (
            <FaPlay />
          ) : (
            <AiOutlineRedo />
          )}
        </span>
        <span> {btnName}</span>
      </div>
    </button>
  );
};

export default ActionsBtn;
